define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var ServerGroupModel = /** @class */ (function () {
        function ServerGroupModel(data) {
            this.Id = ko.observable(0);
            this.ServerGroupName = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, ServerGroupModel.Mapping, self);
            }
        }
        ServerGroupModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new ServerGroupModel(options.data);
            }
        };
        return ServerGroupModel;
    }());
    return ServerGroupModel;
});
//# sourceMappingURL=ServerGroupModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/ServerGroupModel.js
// module id = 268
// module chunks = 2